<template>
	<div style="">
		<div class="midlle">
			<div class="midller-top">
				<div class="top-item">
					<div class="header">
						<div>
							核心用户
						</div>
						<div v-if="userInfo.authentication.university || userInfo.authentication.company"
							style="width: 79px;height: 27px;background: #0052D9;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 27px;">
							已认证
						</div>
					</div>
					<p   v-if="userInfo.authentication.university || userInfo.authentication.company"
					style="margin-top: 10px; font-size: 14px;
							font-family: PingFang; 
							font-weight: 400;color: #0052D9;"><span v-if="userInfo.authentication.university">{{userInfo.authentication.university}}、</span>
							<span v-if="userInfo.authentication.company">{{userInfo.authentication.company}}</span></p>
							<p  v-else
							style="margin-top: 10px; font-size: 14px;
									font-family: PingFang; 
									font-weight: 400;color: #0052D9;">未认证</p>
					<div class="clounm">
						<div class="title">
							<span class="justi">当前特权</span>: <span
								style="font-weight: normal;color: #636363;">{{userInfo.prerogative}}</span>
						</div>
					</div>
					<div class="clounm">
						<div class="title">
							<span class="justi">关注人数</span>: <span
								style="font-weight: normal;color: #636363;">{{userInfo.fens_num}}</span>
						</div>
					</div>
					<!-- <div class="clounm">
						<div class="title">
							<span class="justi">勋章</span>: <span style="font-weight: normal;color: #636363;">伯乐3级</span>
						</div>
					</div> -->
				</div>
				<div class="top-item">
					<div style="margin-top: 0;">
						<span style="font-weight: bold;">积分：</span> <span
							style="font-weight: normal;color: #636363;">永久{{userInfo.score}}&ensp;当日{{userInfo.today_score}}分</span>
					</div>
					<div style="margin-top: 15px;">
						<span style="font-weight: bold;">活跃：</span> <span
							style="font-weight: normal;color: #636363;">{{userInfo.active}}</span>
					</div>
					<div style="margin-top: 15px;">
						<span style="font-weight: bold;">声望：</span> <span
							style="font-weight: normal;color: #636363;">{{userInfo.prestige}}</span>
					</div>
					<div style="margin-top: 15px;">
						<span style="font-weight: bold;">贡献：</span> <span
							style="font-weight: normal;color: #636363;">{{userInfo.contribution}}</span>
					</div>
					<!-- 		<div style="margin-top: 15px;">
						<span style="font-weight: bold;">背书：</span> <span
							style="font-weight: normal;color: #636363;">伯乐3级</span>
					</div> -->
				</div>
			</div>
			<div class="swicthBox">
				<div @click="swicth = 1" :class="['swicth-item',swicth == 1 ? 'item-active' : '']">
					积分
				</div>
				<div @click="swicth = 2" :class="['swicth-item',swicth == 2 ? 'item-active' : '']">
					活跃
				</div>
				<div @click="swicth = 3" :class="['swicth-item',swicth == 3 ? 'item-active' : '']">
					声望
				</div>
				<div @click="swicth = 4" :class="['swicth-item',swicth == 4 ? 'item-active' : '']">
					贡献
				</div>
				<!-- <div @click="swicth = 5" :class="['swicth-item',swicth == 5 ? 'item-active' : '']">
					背书
				</div> -->
				<div @click="swicth = 6" :class="['swicth-item',swicth == 6 ? 'item-active' : '']">
					评论
				</div>
			</div>
			<div class="table tab1" v-if="swicth == 1">
				<el-table :data="getMySocreLog.data" style="width: 100%">
					<el-table-column prop="score" label="积分数量" width="220">
						 <template slot-scope="scope">
						       
						        <span style="color: #0052D9;">{{ scope.row.score>0?'+'+scope.row.score:scope.row.score}}</span>
						      </template>
					</el-table-column>
					<el-table-column prop="memo" label="渠道" width="320">
					</el-table-column>
					<el-table-column label="时间">
						<template slot-scope="scope">
							<p>{{timeConversion(scope.row.createtime)}}</p>
						</template>
					</el-table-column>
				</el-table>
				 <div style="padding: 30px;display: flex;justify-content: center;">
					 <el-pagination
					   background 
					    @current-change="listChangePage($event,'getMySocreLog')"
					   :page-size="getMySocreLog.per_page"
					   layout="prev, pager, next"
					   :total="getMySocreLog.total">
					 </el-pagination>
				 </div>
			</div>
			<div class="table tab1" v-if="swicth == 2">
				<el-table :data="getMyActiveSocreLog.data" style="width: 100%">
					<el-table-column prop="score" label="积分数量" width="220">
						 <template slot-scope="scope">
						       
						        <span style="color: #0052D9;">{{ scope.row.active>0?'+'+scope.row.active:scope.row.active}}</span>
						      </template>
					</el-table-column>
					<el-table-column prop="memo" label="渠道" width="320">
					</el-table-column>
					<el-table-column label="时间">
						<template slot-scope="scope">
							<p>{{timeConversion(scope.row.createtime)}}</p>
						</template>
					</el-table-column>
				</el-table>
				 <div style="padding: 30px;display: flex;justify-content: center;">
					 <el-pagination
					   background
					    @current-change="listChangePage($event,'getMyActiveSocreLog')"
					   :page-size="getMyActiveSocreLog.per_page"
					   layout="prev, pager, next"
					   :total="getMyActiveSocreLog.total">
					 </el-pagination>
				 </div>
			</div>
			<div class="table tab1" v-if="swicth == 3">
				<el-table :data="getMySWSocreLog.data" style="width: 100%">
					<el-table-column prop="score" label="积分数量" width="220">
						 <template slot-scope="scope">
						       
						        <span style="color: #0052D9;">{{ scope.row.prestige>0?'+'+scope.row.prestige:scope.row.prestige}}</span>
						      </template>
					</el-table-column>
					<el-table-column prop="memo" label="渠道" width="320">
					</el-table-column>
					<el-table-column label="时间">
						<template slot-scope="scope">
							<p>{{timeConversion(scope.row.createtime)}}</p>
						</template>
					</el-table-column>
				</el-table>
				 <div style="padding: 30px;display: flex;justify-content: center;">
					 <el-pagination
					   background
					   @current-change="listChangePage($event,'getMySWSocreLog')"
					   :page-size="getMySWSocreLog.per_page"
					   layout="prev, pager, next"
					   :total="getMySWSocreLog.total">
					 </el-pagination>
				 </div>
			</div>
		<div class="table tab1" v-if="swicth == 4">
			<el-table :data="getGXSocreLog.data" style="width: 100%">
				<el-table-column prop="score" label="积分数量" width="220">
					 <template slot-scope="scope">
					       
					        <span style="color: #0052D9;">{{ scope.row.contribution>0?'+'+scope.row.contribution:scope.row.contribution}}</span>
					      </template>
				</el-table-column>
				<el-table-column prop="memo" label="渠道" width="320">
				</el-table-column>
				<el-table-column label="时间">
					<template slot-scope="scope">
						<p>{{timeConversion(scope.row.createtime)}}</p>
					</template>
				</el-table-column>
			</el-table>
			 <div style="padding: 30px;display: flex;justify-content: center;">
				 <el-pagination
				   background
				   @current-change="listChangePage($event,'getGXSocreLog')"
				   :page-size="getGXSocreLog.per_page"
				   layout="prev, pager, next"
				   :total="getGXSocreLog.total">
				 </el-pagination>
			 </div>
		</div>
<!-- 			<div style="background: #fff;padding: 30px 40px;" v-if="swicth == 5">
				<div style="margin-bottom: 30px;">
					<div class="beishu-item">
						<div class="dian"></div>
						<div style="margin-left: 10px;">张三研究员在XXX领域走在了世界前列</div>
					</div>
					<p style="margin-left: 15px;color: #888;font-size: 14px;margin-top: 5px;">——XXX院士
					</p>
				</div>
				<div style="margin-bottom:30px;">
					<div class="beishu-item">
						<div class="dian"></div>
						<div style="margin-left: 10px;">张三研究员在XXX领域走在了世界前列</div>
					</div>
					<p style="margin-left: 15px;color: #888;font-size: 14px;margin-top: 5px;">——XXX院士
					</p>
				</div>
			<div style="margin-top: 15px; padding:20px ;display: flex;justify-content: center;">
			 <el-pagination
				   background
				   layout="prev, pager, next"
				 :total="1000">
			 </el-pagination>
			</div>
			</div> 
	
			-->
			<div class="zhengshu" v-if="swicth == 6">
				
				<div class="pinglun" v-for="(item,index) in getCommentMeLog.data">
					<div class="userInfo">
						<div style="width: 70px;height: 70px;border-radius: 50%;overflow: hidden;">
							<img :src='getImgSrc(item.avatar)' style="width: 100%;height: 100%;" alt="">
						</div>
						<p>{{item.user_nickname}}</p>
					</div>
					<div class="content">
						<p style="display: flex;color: black;">满意度：<el-rate :value="item.score" disabled></el-rate></p>
						<!-- <p style="font-size: 14px;">{{item.d}}</p> -->
						<div :class="'collapse'" :style="item.collapse ?
						'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;width: 700px;text-overflow: ellipsis;'
						:''">
						{{item.remark}}</div>
						<div style="float: right;cursor: pointer;margin-top: 8px;" @click='item.collapse = !item.collapse'>
													<div v-if="item.collapse">展开 <i class="el-icon-caret-bottom"></i></div>
													<div v-else>收起 <i class="el-icon-caret-top"></i></div>
												</div>
					</div>
				</div>
				<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
				 <el-pagination
					  background
					  
					   @current-change="listChangePage($event,'getCommentMeLog')"
					  :page-size="getCommentMeLog.per_page"
					  layout="prev, pager, next"
					  :total="getCommentMeLog.total">
				 </el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo:[],
				
				swicth: 1,

				getMySocreLog:[],
				getCommentMeLog:[],
				getMySWSocreLog:[],
				getMyActiveSocreLog:[],
				getGXSocreLog:[],
				plList:[],
				listObj: {
					getMySocreLog:async (page)=>{
						return await this.$api.getMySocreLog({page:page})
					},
					getCommentMeLog:async (page)=>{
						return await this.$api.getCommentMeLog({page:page})
					},
					getMySWSocreLog:async (page)=>{
						return await this.$api.getMySWSocreLog({page:page})
					},
					getMyActiveSocreLog:async (page)=>{
						return await this.$api.getMyActiveSocreLog({page:page})
					},
					GeniusActiveRank:async (page)=>{
						return await this.$api.GeniusActiveRank({page:page})
					},
					getGXSocreLog:async (page)=>{
						return await this.$api.getGXSocreLog({page:page})
					},
				},
			}
		},
		created() {
			this.platformInfo()
			this.getMyList()
		},
		methods:{
			listChangePage(page,type){
				this.listObj[type].page = page
				this.listObj[type](this.listObj[type].page).then(res=>{
					this[type] = res.data
				})
			},
			collapseChange(index){
				console.log(this.plList[index]);
				this.plList[index].collapse = !this.plList[index].collapse
			},
			async getMyList(){
				const list1 = await this.$api.getMySocreLog()
				this.getMySocreLog = list1.data
				const list2 = await this.$api.getCommentMeLog()
				let arr = list2.data
				arr.data.forEach((item)=>{
					item.collapse = true
					item.score*=1
				})
				console.log(list2.data.data);
				this.getCommentMeLog = arr
				const list3 = await this.$api.getMySWSocreLog()
				this.getMySWSocreLog = list3.data
				const list4 = await this.$api.getMyActiveSocreLog()
				this.getMyActiveSocreLog = list4.data
				const list5 = await this.$api.getGXSocreLog()
				this.getGXSocreLog = list5.data
			},
			async platformInfo(){
				const info = await this.$api.userPlatformInfo()
				console.log(info.data);
				this.userInfo = info.data
			},
			subOrPuls(num){
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.pinglun{
		
		.collapse{
			margin-top: 15px;
		}
		color: #909090;
		display: flex;
		align-items: flex-start;
		border-bottom: 1px dashed #eee;
		padding-bottom: 20px;
		margin-bottom: 30px;
		.content{
			margin-left: 28px;
			width: 630px;
			
			&>p{
				
			}
		}
		.userInfo{
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: center;
			p{
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}
	.zhengshu {
		display: flex;
		flex-wrap: wrap;
		padding: 30px 30px;
		background: #fff;
		box-sizing: border-box;
		.img {
			display: flex;
			justify-content: center;
			margin-right: 40px;
			margin-bottom: 30px;
		}
	}
	.dian {
		display: inline-block;
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background: #0052D9;
	}
	.beishu-item {
		display: flex;
		align-items: center;
	}
	.beishu {
		padding: 35px 30px;
		box-sizing: border-box;
	}
	.midlle {
		
	
		/deep/.el-table th.el-table__cell.is-leaf {
			border: none;
			background: #FAFAFA;
		}

		/deep/.el-table__cell {
			text-align: left;
			padding-left: 25px;
		}
		/deep/.el-pager li:not(.disabled).active{
			background: #0052D9;
		}
		.table {
			background: #FFFFFF;
		}

		.head-title {
			display: flex;
			padding: 0 30px;
			height: 60px;
			border: 1px solid #EEEEEE;
			border-left: none;
			border-right: none;
			line-height: 60px;
			font-weight: bold;
		}

		.swicthBox {
			font-size: 18px;
			margin-top: 20px;
			height: 70px;
			line-height: 70px;
			display: flex;
			background: #FFFFFF;

			.swicth-item {
				cursor: pointer;
				margin: 0 35px;
				text-align: center;
			}

			.item-active {
				color: #0052D9;
				font-weight: 550;
				border-bottom: 5px solid #0052D9;
			}
		}

		width: 860px;
		padding: 0 20px;
		box-sizing: border-box;

		.midller-top {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.top-item {
				.clounm {
					margin-top: 15px;
					display: flex;

					.title {
						font-weight: bold;

						.justi {
							display: inline-block;
							text-align-last: justify;
							text-align: justify;
							width: 65px;
						}
					}
				}

				font-size: 16px;

				.header {
					display: flex;
					justify-content: space-between;
				}

				padding: 20px 0 20px 20px;
				box-sizing: border-box;
				width: 400px;
				height: 170px;
				background: #FFFFFF;
			}
		}
	}
</style>